<template >
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0 p-5" style="    margin: 1vw .9vw;">
        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="d-flex">
            <small class="fw-bolder"><span>تدوین ارکان جهت ساز</span> / <span>  مولفه های ارکان جهت ساز   </span></small>

          </div>
          <button class="btn btn-primary btn-submit-1" @click="$router.push(`/Vision_working_group`)">برگشت</button>
        </div>
        <hr class="mb-3">
        <div class="d-flex flex-nowrap">
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center ">
            <h3>  علت یا فلسفه وجودی	</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/1" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item1">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>زمینه فعالیت محصول  	</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/2" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item2">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>  مشتری</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/3" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item3">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>  بازار</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/4" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item4">🟢</span><span v-else>🔴</span></p>
          </div>
        </div>
        <div class="d-flex flex-nowrap mt-2">
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center ">
            <h3>بقاء، رشد و سودآوری		</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/5" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item5">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>مزیت رقابتی با ویژگی متمایز		</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/6" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item6">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>  فن آوری	</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/7" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item7">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>  تصور مردم	</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/8" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item8">🟢</span><span v-else>🔴</span></p>
          </div>
        </div>
        <div class="d-flex flex-nowrap mt-2">
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center ">
            <h3>کارکنان		</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/9" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item9">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>ماموریت بالادستی			</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/10" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item10">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>  عوامل کلیدی مستمر	  	</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/11" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item11">🟢</span><span v-else>🔴</span></p>
          </div>
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center mx-1">
            <h3>    الزامات محیطی		</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/12" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item12">🟢</span><span v-else>🔴</span></p>
          </div>
        </div>
        <div class="d-flex flex-nowrap mt-2">
          <div class="card col-3 p-3 d-flex flex-column align-items-center justify-content-center ">
            <h3>الزامات داخلی			</h3>
            <router-link to="/Vision_working_group_Gary_Hamel_questionnaire/ByType/13" class="btn btn-submit-1 btn-primary" style="width: 10vw !important;">تکمیل اطلاعات/بروزرسانی</router-link>
            <p class="mt-3"><span>وضعیت تکمیل:</span><span v-if="item13">🟢</span><span v-else>🔴</span></p>
          </div>

        </div>
        <hr class="mt-2">

        <div class="d-flex flex-row mt-2 ">
          <small class=""><span>تکمیل شده  :</span><span>🟢</span></small>

          <small class=""><span>تکمیل نشده  :</span> <span>🔴</span></small>
        </div>


        <hr class="mt-2 mb-2">
        <center>
          <router-link to="/Vision_working_group_future" class="btn btn-submit-1 btn-primary">مرحله بعدی</router-link>
        </center>



      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Sidebar from "@/components/Sidebar/Sidebar";
import splash from "@/components/Splash/Splash";
import router from "@/router";

export default {
  name: 'HomeView',
  components: {
    Sidebar,
    splash
  },
  data(){
    return{
      item1: false,
      item2: false,
      item3: false,
      item4: false,
      item5: false,
      item6: false,
      item7: false,
      item8: false,
      item9: false,
      item10: false,
      item11: false,
      item12: false,
      item13: false,
    }
  },
  methods:{
    checkIsMother(){
      if (this.is_mother){
        router.push('/mother_items')
        return
      }

    },
    all(){
      fetch(`${this.base_url}/HamelQuestionnaire/check`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',
        },
        body: JSON.stringify({

        }),
      })
          .then(response => response.json())
          .then((response) => {
            if (response.data){
              this.item1 = response.data[0]
              this.item2 = response.data[1]
              this.item3 = response.data[2]
              this.item4 = response.data[3]
              this.item5 = response.data[4]
              this.item6 = response.data[5]
              this.item7 = response.data[6]
              this.item8 = response.data[7]
              this.item9 = response.data[8]
              this.item10 = response.data[9]
              this.item11 = response.data[10]
              this.item12 = response.data[11]
              this.item13 = response.data[12]
            }


          }).catch((err) => {
      })
    },
  },
  mounted() {
    this.checkIsMother()
    this.all()
  }
}
</script>
<style scoped lang="scss">
a{
  font-size: 1vw;
}

/*.line_after{
  position: relative;
  &::after{
    position: absolute;
    width: 0.01vw;
    height: 53vw;
    content: '';
    background-color: #efecf3 !important;
    top: 5vw;
    right: 35.3vw ;
    border-radius: 1vw;
  }
}*/

h3{
  font-size: 1.3vw !important;
}
small,span{
  font-size: 1vw !important;
}
</style>